// extracted by mini-css-extract-plugin
module.exports = {"actionContainer":"DesignerDetailsRenderer_actionContainer_1NvmN"};